var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiPortal from '@material-ui/core/Portal';
/**
 * Kareo wrapped component of the Material-UI Portal. The prop API has been limited to props defined in PortalProps.
 *
 * The portal component renders its children into a new "subtree" outside of current DOM hierarchy.
 *
 * Material-UI Portal: [Docs](https://v4.mui.com/components/portal/), [API](https://v4.mui.com/api/portal/)
 *
 * @storybook: [Portal](http://design.kareoprod.ent/design-system/?path=/story/components-utils-portal--popover-portal-in-list)
 */
var Portal = function (props) { return (React.createElement(MuiPortal, __assign({}, props))); };
Portal.displayName = 'KareoPortal';
export default Portal;
